export const LineOfBusinesses = {
    S4A: 'S4A',
    S4A_STAGING: 'S4A_STAGING',
    S4P: 'S4P',
    S4P_STAGING: 'S4P_STAGING',
    CONSUMER: 'CONSUMER',
    CONSUMER_STAGING: 'CONSUMER_STAGING',
};
